import JsonApiDeserializer from "../services/JsonApiDeserializer";

export class ListManager {

    list = [];

    loadingPrev = false;
    errorPrev = true;

    loadingNext = false;
    errorNext = true;

    reachedLimit = false;

    getPrevRequest = () => new Promise((resolve, reject) => {});
    getNextRequest = () => new Promise((resolve, reject) => {});

    getPrev = () => {
        this.loadingPrev = true;
        this.errorPrev = false;

        return this.getPrevRequest()
            .then((res) => {
                const items = JsonApiDeserializer.deserializeItems(res.data, res.included);
                this.list.unshift(...items);
                this.loadingPrev = false;
                return items;
            })
            .catch(e => {
                console.log(e);
                this.loadingPrev = false;
                this.errorPrev = true;
                return e;
            });
    };

    getNext = () => {
        if (this.reachedLimit) return new Promise((resolve, reject) => []);

        this.loadingNext = true;
        this.errorNext = false;

        return this.getNextRequest()
            .then((res) => {
                const items = JsonApiDeserializer.deserializeItems(res.data, res.included);
                this.list.push(...items);
                this.loadingNext = false;
                this.reachedLimit = res.meta.pagination.total_pages === res.meta.pagination.current_page;
                return items;
            })
            .catch(e => {
                console.log(e);
                this.errorNext = true;
                this.loadingNext = false;
                return e;
            });
    };
}


// WEBPACK FOOTER //
// ./utilities/list-manager.js